import React, {Component} from 'react';
import PropTypes from 'prop-types';
import apiHelper from 'helpers/api-helper';
import {errorUiTexts} from 'data/ui-texts';
import CreateUser from './create-user';

class CreateUserController extends Component {
	constructor(props) {
		super(props);
		this.state = {
			isLoading: false,
			userCreated: false,
			email: null,
			password: null,
			passwordRepeat: null,
			feedback: null
		};
	};

	/**
	 * Update input fields
	 * @param {obj} event 
	 */
	handleInput = (event) => {
		let value = event.target.value;
		let name = event.target.name;
		this.setState({
			[name]: value,
			feedback: null
		});
	};

	/**
	 * Handle create user request
 	 * @param {obj} event 
 	 */
	handleCreateUser = (event) => {
		event.preventDefault();

		if (this.state.isLoading) return;

		this.setState({isLoading: true}, () => {
			let email = this.state.email;
			let password = this.state.password;
			let passwordRepeat = this.state.passwordRepeat;
			let feedback = null;
	
			/* Check for empty fields */
			if (!email || !password || !passwordRepeat) feedback = errorUiTexts.emptyFields;

			const lowercaseEmail = email.toLowerCase().trim();
	
			/* Check valid e-mail */
			if (!feedback && lowercaseEmail.indexOf('@') < 0) feedback = errorUiTexts.invalidEmail;
			
			/* Check if passwords match */
			if (!feedback) {
				if (password && password.length < 8) {
					feedback = errorUiTexts.invalidPassword;
				} else if (password && password !== passwordRepeat) {
					feedback = errorUiTexts.noPasswordMatch;
				}
			}
	
			if (feedback) {
				/* Error feedback */
				this.setState({isLoading: false, feedback});
			} else {
				/* Create user */
				this.createFirebaseUser(lowercaseEmail, password);
			}
		});
	};

	/**
	 * Create user
	 * @param {string} email 
	 * @param {string} password 
	 */
	createFirebaseUser = (email, password) => {
		apiHelper('facilitator/create-facilitator', {
			email: email,
			password: password
		}).then(
			(response)=>{
				if (response.status === 'success') {
					this.setState({userCreated: true, isLoading: false});
				} else {
					console.error(response);
					let feedback = errorUiTexts.unknownError;
					if (response.error === 'user-not-allowed') feedback = errorUiTexts.userNotAllowed;
					if (response.error === 'auth/email-already-exists') feedback = errorUiTexts.emailExists;
					this.setState({isLoading: false, feedback: feedback});
				}
			},
			(error) => {
				console.error(error);
				this.setState({isLoading: false, feedback: errorUiTexts.unknownError});
			}
		);
	};

	/**
	 * Render create user component
	 */
	render() {
		return (
			<CreateUser
				isLoading={this.state.isLoading}
				userCreated={this.state.userCreated}
				email={this.state.email}
				password={this.state.password}
				passwordRepeat={this.state.passwordRepeat}
				feedback={this.state.feedback}
				handleInput={this.handleInput}
				handleCreateUser={this.handleCreateUser}
				setFacilitatorBoxType={this.props.setFacilitatorBoxType}
			/>
		);		
	}
}

CreateUserController.propTypes = {
	setFacilitatorBoxType: PropTypes.func.isRequired,
};

export default CreateUserController;